//@ts-nocheck
  // DO NOT MODIFY THIS FILE. This file is automatically generated by Tina
  export function gql(strings: TemplateStringsArray, ...args: string[]): string {
    let str = ''
    strings.forEach((string, i) => {
      str += string + (args[i] || '')
    })
    return str
  }
  export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** References another document, used as a foreign key */
  Reference: any;
  JSON: any;
};

export type SystemInfo = {
  __typename?: 'SystemInfo';
  filename: Scalars['String'];
  title?: Maybe<Scalars['String']>;
  basename: Scalars['String'];
  breadcrumbs: Array<Scalars['String']>;
  path: Scalars['String'];
  relativePath: Scalars['String'];
  extension: Scalars['String'];
  template: Scalars['String'];
  collection: Collection;
};


export type SystemInfoBreadcrumbsArgs = {
  excludeExtension?: InputMaybe<Scalars['Boolean']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  hasPreviousPage: Scalars['Boolean'];
  hasNextPage: Scalars['Boolean'];
  startCursor: Scalars['String'];
  endCursor: Scalars['String'];
};

export type Node = {
  id: Scalars['ID'];
};

export type Document = {
  id: Scalars['ID'];
  _sys?: Maybe<SystemInfo>;
  _values: Scalars['JSON'];
};

/** A relay-compliant pagination connection */
export type Connection = {
  totalCount: Scalars['Float'];
  pageInfo: PageInfo;
};

export type Query = {
  __typename?: 'Query';
  getOptimizedQuery?: Maybe<Scalars['String']>;
  collection: Collection;
  collections: Array<Collection>;
  node: Node;
  document: DocumentNode;
  page: Page;
  pageConnection: PageConnection;
  dances: Dances;
  dancesConnection: DancesConnection;
  courses: Courses;
  coursesConnection: CoursesConnection;
  menu: Menu;
  menuConnection: MenuConnection;
  settings: Settings;
  settingsConnection: SettingsConnection;
};


export type QueryGetOptimizedQueryArgs = {
  queryString: Scalars['String'];
};


export type QueryCollectionArgs = {
  collection?: InputMaybe<Scalars['String']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryDocumentArgs = {
  collection?: InputMaybe<Scalars['String']>;
  relativePath?: InputMaybe<Scalars['String']>;
};


export type QueryPageArgs = {
  relativePath?: InputMaybe<Scalars['String']>;
};


export type QueryPageConnectionArgs = {
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PageFilter>;
};


export type QueryDancesArgs = {
  relativePath?: InputMaybe<Scalars['String']>;
};


export type QueryDancesConnectionArgs = {
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DancesFilter>;
};


export type QueryCoursesArgs = {
  relativePath?: InputMaybe<Scalars['String']>;
};


export type QueryCoursesConnectionArgs = {
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CoursesFilter>;
};


export type QueryMenuArgs = {
  relativePath?: InputMaybe<Scalars['String']>;
};


export type QueryMenuConnectionArgs = {
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<MenuFilter>;
};


export type QuerySettingsArgs = {
  relativePath?: InputMaybe<Scalars['String']>;
};


export type QuerySettingsConnectionArgs = {
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SettingsFilter>;
};

export type DocumentFilter = {
  page?: InputMaybe<PageFilter>;
  dances?: InputMaybe<DancesFilter>;
  courses?: InputMaybe<CoursesFilter>;
  menu?: InputMaybe<MenuFilter>;
  settings?: InputMaybe<SettingsFilter>;
};

export type DocumentConnectionEdges = {
  __typename?: 'DocumentConnectionEdges';
  cursor: Scalars['String'];
  node?: Maybe<DocumentNode>;
};

export type DocumentConnection = Connection & {
  __typename?: 'DocumentConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
  edges?: Maybe<Array<Maybe<DocumentConnectionEdges>>>;
};

export type Collection = {
  __typename?: 'Collection';
  name: Scalars['String'];
  slug: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  path: Scalars['String'];
  format?: Maybe<Scalars['String']>;
  matches?: Maybe<Scalars['String']>;
  templates?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  fields?: Maybe<Array<Maybe<Scalars['JSON']>>>;
  documents: DocumentConnection;
};


export type CollectionDocumentsArgs = {
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DocumentFilter>;
};

export type DocumentNode = Page | Dances | Courses | Menu | SettingsGeneralSettings | SettingsSocialNetworkSettings | SettingsTrackingSettings | SettingsContactSettings;

export type PageParentPage = Page;

export type PageContentWidgetCustomContentLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetCustomContentLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetCustomContentLinkNodesInternalLink';
  label?: Maybe<Scalars['String']>;
  internalLink?: Maybe<PageContentWidgetCustomContentLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']>;
};

export type PageContentWidgetCustomContentLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetCustomContentLinkNodesExternalLink';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PageContentWidgetCustomContentLinkNodesFileLink = {
  __typename?: 'PageContentWidgetCustomContentLinkNodesFileLink';
  label?: Maybe<Scalars['String']>;
  fileLink?: Maybe<Scalars['String']>;
};

export type PageContentWidgetCustomContentLinkNodes = PageContentWidgetCustomContentLinkNodesInternalLink | PageContentWidgetCustomContentLinkNodesExternalLink | PageContentWidgetCustomContentLinkNodesFileLink;

export type PageContentWidgetCustomContentImageNode = {
  __typename?: 'PageContentWidgetCustomContentImageNode';
  image?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['String']>;
};

export type PageContentWidgetCustomContent = {
  __typename?: 'PageContentWidgetCustomContent';
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSON']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetCustomContentLinkNodes>>>;
  imageNode?: Maybe<PageContentWidgetCustomContentImageNode>;
};

export type PageContentWidgetBannerImage = {
  __typename?: 'PageContentWidgetBannerImage';
  image?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetBannerTextLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetBannerTextLinkNodesInternalLink';
  label?: Maybe<Scalars['String']>;
  internalLink?: Maybe<PageContentWidgetBannerTextLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetBannerTextLinkNodesExternalLink';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodesFileLink = {
  __typename?: 'PageContentWidgetBannerTextLinkNodesFileLink';
  label?: Maybe<Scalars['String']>;
  fileLink?: Maybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodes = PageContentWidgetBannerTextLinkNodesInternalLink | PageContentWidgetBannerTextLinkNodesExternalLink | PageContentWidgetBannerTextLinkNodesFileLink;

export type PageContentWidgetBannerText = {
  __typename?: 'PageContentWidgetBannerText';
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSON']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetBannerTextLinkNodes>>>;
};

export type PageContentWidgetImageGridGridImageNodes = {
  __typename?: 'PageContentWidgetImageGridGridImageNodes';
  image?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
  aspectRatio?: Maybe<Scalars['String']>;
};

export type PageContentWidgetImageGridGrid = {
  __typename?: 'PageContentWidgetImageGridGrid';
  imageNodes?: Maybe<Array<Maybe<PageContentWidgetImageGridGridImageNodes>>>;
};

export type PageContentWidgetImageGrid = {
  __typename?: 'PageContentWidgetImageGrid';
  grid?: Maybe<Array<Maybe<PageContentWidgetImageGridGrid>>>;
};

export type PageContentWidgetHeroUnitLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetHeroUnitLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetHeroUnitLinkNodesInternalLink';
  label?: Maybe<Scalars['String']>;
  internalLink?: Maybe<PageContentWidgetHeroUnitLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnitLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetHeroUnitLinkNodesExternalLink';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnitLinkNodesFileLink = {
  __typename?: 'PageContentWidgetHeroUnitLinkNodesFileLink';
  label?: Maybe<Scalars['String']>;
  fileLink?: Maybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnitLinkNodes = PageContentWidgetHeroUnitLinkNodesInternalLink | PageContentWidgetHeroUnitLinkNodesExternalLink | PageContentWidgetHeroUnitLinkNodesFileLink;

export type PageContentWidgetHeroUnitImageNode = {
  __typename?: 'PageContentWidgetHeroUnitImageNode';
  image?: Maybe<Scalars['String']>;
  alt?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnit = {
  __typename?: 'PageContentWidgetHeroUnit';
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSON']>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetHeroUnitLinkNodes>>>;
  imageNode?: Maybe<PageContentWidgetHeroUnitImageNode>;
};

export type PageContentWidgetListingListing = {
  __typename?: 'PageContentWidgetListingListing';
  title: Scalars['String'];
  content?: Maybe<Scalars['JSON']>;
};

export type PageContentWidgetListingLinkNodesInternalLinkInternalLink = Page;

export type PageContentWidgetListingLinkNodesInternalLink = {
  __typename?: 'PageContentWidgetListingLinkNodesInternalLink';
  label?: Maybe<Scalars['String']>;
  internalLink?: Maybe<PageContentWidgetListingLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']>;
};

export type PageContentWidgetListingLinkNodesExternalLink = {
  __typename?: 'PageContentWidgetListingLinkNodesExternalLink';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type PageContentWidgetListingLinkNodesFileLink = {
  __typename?: 'PageContentWidgetListingLinkNodesFileLink';
  label?: Maybe<Scalars['String']>;
  fileLink?: Maybe<Scalars['String']>;
};

export type PageContentWidgetListingLinkNodes = PageContentWidgetListingLinkNodesInternalLink | PageContentWidgetListingLinkNodesExternalLink | PageContentWidgetListingLinkNodesFileLink;

export type PageContentWidgetListing = {
  __typename?: 'PageContentWidgetListing';
  title?: Maybe<Scalars['String']>;
  introduction?: Maybe<Scalars['JSON']>;
  listing?: Maybe<Array<Maybe<PageContentWidgetListingListing>>>;
  linkNodes?: Maybe<Array<Maybe<PageContentWidgetListingLinkNodes>>>;
};

export type PageContentWidgetContactForm = {
  __typename?: 'PageContentWidgetContactForm';
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  sendButton?: Maybe<Scalars['String']>;
  resendButton?: Maybe<Scalars['String']>;
  successMessage?: Maybe<Scalars['JSON']>;
  errorMessage?: Maybe<Scalars['JSON']>;
};

export type PageContentWidgetAnchor = {
  __typename?: 'PageContentWidgetAnchor';
  name?: Maybe<Scalars['String']>;
};

export type PageContentWidgetAgenda = {
  __typename?: 'PageContentWidgetAgenda';
  title?: Maybe<Scalars['String']>;
};

export type PageContent = PageContentWidgetCustomContent | PageContentWidgetBannerImage | PageContentWidgetBannerText | PageContentWidgetImageGrid | PageContentWidgetHeroUnit | PageContentWidgetListing | PageContentWidgetContactForm | PageContentWidgetAnchor | PageContentWidgetAgenda;

export type PageSeo = {
  __typename?: 'PageSeo';
  title?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
};

export type Page = Node & Document & {
  __typename?: 'Page';
  title: Scalars['String'];
  path: Scalars['String'];
  parentPage?: Maybe<PageParentPage>;
  draft?: Maybe<Scalars['Boolean']>;
  content?: Maybe<Array<Maybe<PageContent>>>;
  seo?: Maybe<PageSeo>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type StringFilter = {
  startsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageParentPageFilter = {
  page?: InputMaybe<PageFilter>;
};

export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
};

export type RichTextFilter = {
  startsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
};

export type PageContentWidgetCustomContentLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetCustomContentLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
};

export type PageContentWidgetCustomContentLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type ImageFilter = {
  startsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PageContentWidgetCustomContentLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
};

export type PageContentWidgetCustomContentLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesFileLinkFilter>;
};

export type PageContentWidgetCustomContentImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<StringFilter>;
  position?: InputMaybe<StringFilter>;
};

export type PageContentWidgetCustomContentFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  linkNodes?: InputMaybe<PageContentWidgetCustomContentLinkNodesFilter>;
  imageNode?: InputMaybe<PageContentWidgetCustomContentImageNodeFilter>;
};

export type PageContentWidgetBannerImageFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<StringFilter>;
};

export type PageContentWidgetBannerTextLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetBannerTextLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetBannerTextLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
};

export type PageContentWidgetBannerTextLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type PageContentWidgetBannerTextLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
};

export type PageContentWidgetBannerTextLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetBannerTextLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetBannerTextLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetBannerTextLinkNodesFileLinkFilter>;
};

export type PageContentWidgetBannerTextFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  linkNodes?: InputMaybe<PageContentWidgetBannerTextLinkNodesFilter>;
};

export type PageContentWidgetImageGridGridImageNodesFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
  aspectRatio?: InputMaybe<StringFilter>;
};

export type PageContentWidgetImageGridGridFilter = {
  imageNodes?: InputMaybe<PageContentWidgetImageGridGridImageNodesFilter>;
};

export type PageContentWidgetImageGridFilter = {
  grid?: InputMaybe<PageContentWidgetImageGridGridFilter>;
};

export type PageContentWidgetHeroUnitLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetHeroUnitLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetHeroUnitLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
};

export type PageContentWidgetHeroUnitLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type PageContentWidgetHeroUnitLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
};

export type PageContentWidgetHeroUnitLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetHeroUnitLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetHeroUnitLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetHeroUnitLinkNodesFileLinkFilter>;
};

export type PageContentWidgetHeroUnitImageNodeFilter = {
  image?: InputMaybe<ImageFilter>;
  alt?: InputMaybe<StringFilter>;
  credits?: InputMaybe<StringFilter>;
};

export type PageContentWidgetHeroUnitFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  linkNodes?: InputMaybe<PageContentWidgetHeroUnitLinkNodesFilter>;
  imageNode?: InputMaybe<PageContentWidgetHeroUnitImageNodeFilter>;
};

export type PageContentWidgetListingListingFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
};

export type PageContentWidgetListingLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type PageContentWidgetListingLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<PageContentWidgetListingLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
};

export type PageContentWidgetListingLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type PageContentWidgetListingLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
};

export type PageContentWidgetListingLinkNodesFilter = {
  internalLink?: InputMaybe<PageContentWidgetListingLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<PageContentWidgetListingLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<PageContentWidgetListingLinkNodesFileLinkFilter>;
};

export type PageContentWidgetListingFilter = {
  title?: InputMaybe<StringFilter>;
  introduction?: InputMaybe<RichTextFilter>;
  listing?: InputMaybe<PageContentWidgetListingListingFilter>;
  linkNodes?: InputMaybe<PageContentWidgetListingLinkNodesFilter>;
};

export type PageContentWidgetContactFormFilter = {
  title?: InputMaybe<StringFilter>;
  content?: InputMaybe<RichTextFilter>;
  name?: InputMaybe<StringFilter>;
  sendButton?: InputMaybe<StringFilter>;
  resendButton?: InputMaybe<StringFilter>;
  successMessage?: InputMaybe<RichTextFilter>;
  errorMessage?: InputMaybe<RichTextFilter>;
};

export type PageContentWidgetAnchorFilter = {
  name?: InputMaybe<StringFilter>;
};

export type PageContentWidgetAgendaFilter = {
  title?: InputMaybe<StringFilter>;
};

export type PageContentFilter = {
  WidgetCustomContent?: InputMaybe<PageContentWidgetCustomContentFilter>;
  WidgetBannerImage?: InputMaybe<PageContentWidgetBannerImageFilter>;
  WidgetBannerText?: InputMaybe<PageContentWidgetBannerTextFilter>;
  WidgetImageGrid?: InputMaybe<PageContentWidgetImageGridFilter>;
  WidgetHeroUnit?: InputMaybe<PageContentWidgetHeroUnitFilter>;
  WidgetListing?: InputMaybe<PageContentWidgetListingFilter>;
  WidgetContactForm?: InputMaybe<PageContentWidgetContactFormFilter>;
  WidgetAnchor?: InputMaybe<PageContentWidgetAnchorFilter>;
  WidgetAgenda?: InputMaybe<PageContentWidgetAgendaFilter>;
};

export type PageSeoFilter = {
  title?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  keywords?: InputMaybe<StringFilter>;
  image?: InputMaybe<ImageFilter>;
};

export type PageFilter = {
  title?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  parentPage?: InputMaybe<PageParentPageFilter>;
  draft?: InputMaybe<BooleanFilter>;
  content?: InputMaybe<PageContentFilter>;
  seo?: InputMaybe<PageSeoFilter>;
};

export type PageConnectionEdges = {
  __typename?: 'PageConnectionEdges';
  cursor: Scalars['String'];
  node?: Maybe<Page>;
};

export type PageConnection = Connection & {
  __typename?: 'PageConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
  edges?: Maybe<Array<Maybe<PageConnectionEdges>>>;
};

export type Dances = Node & Document & {
  __typename?: 'Dances';
  title: Scalars['String'];
  choreographer?: Maybe<Scalars['String']>;
  video_teacher?: Maybe<Scalars['String']>;
  video?: Maybe<Scalars['String']>;
  file?: Maybe<Scalars['String']>;
  notes?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type DancesFilter = {
  title?: InputMaybe<StringFilter>;
  choreographer?: InputMaybe<StringFilter>;
  video_teacher?: InputMaybe<StringFilter>;
  video?: InputMaybe<StringFilter>;
  file?: InputMaybe<ImageFilter>;
  notes?: InputMaybe<RichTextFilter>;
};

export type DancesConnectionEdges = {
  __typename?: 'DancesConnectionEdges';
  cursor: Scalars['String'];
  node?: Maybe<Dances>;
};

export type DancesConnection = Connection & {
  __typename?: 'DancesConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
  edges?: Maybe<Array<Maybe<DancesConnectionEdges>>>;
};

export type CoursesDancesDance = Dances;

export type CoursesDances = {
  __typename?: 'CoursesDances';
  dance?: Maybe<CoursesDancesDance>;
  notes?: Maybe<Scalars['String']>;
};

export type Courses = Node & Document & {
  __typename?: 'Courses';
  title: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  season?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['JSON']>;
  dances?: Maybe<Array<Maybe<CoursesDances>>>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type DatetimeFilter = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CoursesDancesDanceFilter = {
  dances?: InputMaybe<DancesFilter>;
};

export type CoursesDancesFilter = {
  dance?: InputMaybe<CoursesDancesDanceFilter>;
  notes?: InputMaybe<StringFilter>;
};

export type CoursesFilter = {
  title?: InputMaybe<StringFilter>;
  date?: InputMaybe<DatetimeFilter>;
  season?: InputMaybe<StringFilter>;
  description?: InputMaybe<RichTextFilter>;
  dances?: InputMaybe<CoursesDancesFilter>;
};

export type CoursesConnectionEdges = {
  __typename?: 'CoursesConnectionEdges';
  cursor: Scalars['String'];
  node?: Maybe<Courses>;
};

export type CoursesConnection = Connection & {
  __typename?: 'CoursesConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
  edges?: Maybe<Array<Maybe<CoursesConnectionEdges>>>;
};

export type MenuLinkNodesInternalLinkInternalLink = Page;

export type MenuLinkNodesInternalLink = {
  __typename?: 'MenuLinkNodesInternalLink';
  label?: Maybe<Scalars['String']>;
  internalLink?: Maybe<MenuLinkNodesInternalLinkInternalLink>;
  anchor?: Maybe<Scalars['String']>;
};

export type MenuLinkNodesExternalLink = {
  __typename?: 'MenuLinkNodesExternalLink';
  label?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type MenuLinkNodesFileLink = {
  __typename?: 'MenuLinkNodesFileLink';
  label?: Maybe<Scalars['String']>;
  fileLink?: Maybe<Scalars['String']>;
};

export type MenuLinkNodes = MenuLinkNodesInternalLink | MenuLinkNodesExternalLink | MenuLinkNodesFileLink;

export type Menu = Node & Document & {
  __typename?: 'Menu';
  name: Scalars['String'];
  position?: Maybe<Scalars['String']>;
  linkNodes?: Maybe<Array<Maybe<MenuLinkNodes>>>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type MenuLinkNodesInternalLinkInternalLinkFilter = {
  page?: InputMaybe<PageFilter>;
};

export type MenuLinkNodesInternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  internalLink?: InputMaybe<MenuLinkNodesInternalLinkInternalLinkFilter>;
  anchor?: InputMaybe<StringFilter>;
};

export type MenuLinkNodesExternalLinkFilter = {
  label?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type MenuLinkNodesFileLinkFilter = {
  label?: InputMaybe<StringFilter>;
  fileLink?: InputMaybe<ImageFilter>;
};

export type MenuLinkNodesFilter = {
  internalLink?: InputMaybe<MenuLinkNodesInternalLinkFilter>;
  externalLink?: InputMaybe<MenuLinkNodesExternalLinkFilter>;
  fileLink?: InputMaybe<MenuLinkNodesFileLinkFilter>;
};

export type MenuFilter = {
  name?: InputMaybe<StringFilter>;
  position?: InputMaybe<StringFilter>;
  linkNodes?: InputMaybe<MenuLinkNodesFilter>;
};

export type MenuConnectionEdges = {
  __typename?: 'MenuConnectionEdges';
  cursor: Scalars['String'];
  node?: Maybe<Menu>;
};

export type MenuConnection = Connection & {
  __typename?: 'MenuConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
  edges?: Maybe<Array<Maybe<MenuConnectionEdges>>>;
};

export type SettingsGeneralSettings = Node & Document & {
  __typename?: 'SettingsGeneralSettings';
  title: Scalars['String'];
  websiteName: Scalars['String'];
  websiteDescription?: Maybe<Scalars['String']>;
  websiteKeywords?: Maybe<Scalars['String']>;
  websiteLogo?: Maybe<Scalars['String']>;
  websiteIcon?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type SettingsSocialNetworkSettingsPlatforms = {
  __typename?: 'SettingsSocialNetworkSettingsPlatforms';
  name: Scalars['String'];
  url: Scalars['String'];
};

export type SettingsSocialNetworkSettings = Node & Document & {
  __typename?: 'SettingsSocialNetworkSettings';
  title: Scalars['String'];
  websiteShareImage?: Maybe<Scalars['String']>;
  platforms?: Maybe<Array<Maybe<SettingsSocialNetworkSettingsPlatforms>>>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type SettingsTrackingSettings = Node & Document & {
  __typename?: 'SettingsTrackingSettings';
  title: Scalars['String'];
  googleAnalyticsId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type SettingsContactSettings = Node & Document & {
  __typename?: 'SettingsContactSettings';
  title: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  companyDescription?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  _sys: SystemInfo;
  _values: Scalars['JSON'];
};

export type Settings = SettingsGeneralSettings | SettingsSocialNetworkSettings | SettingsTrackingSettings | SettingsContactSettings;

export type SettingsGeneralSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  websiteName?: InputMaybe<StringFilter>;
  websiteDescription?: InputMaybe<StringFilter>;
  websiteKeywords?: InputMaybe<StringFilter>;
  websiteLogo?: InputMaybe<ImageFilter>;
  websiteIcon?: InputMaybe<ImageFilter>;
};

export type SettingsSocialNetworkSettingsPlatformsFilter = {
  name?: InputMaybe<StringFilter>;
  url?: InputMaybe<StringFilter>;
};

export type SettingsSocialNetworkSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  websiteShareImage?: InputMaybe<ImageFilter>;
  platforms?: InputMaybe<SettingsSocialNetworkSettingsPlatformsFilter>;
};

export type SettingsTrackingSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  googleAnalyticsId?: InputMaybe<StringFilter>;
};

export type SettingsContactSettingsFilter = {
  title?: InputMaybe<StringFilter>;
  companyName?: InputMaybe<StringFilter>;
  companyDescription?: InputMaybe<StringFilter>;
  companyLogo?: InputMaybe<ImageFilter>;
  email?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
};

export type SettingsFilter = {
  generalSettings?: InputMaybe<SettingsGeneralSettingsFilter>;
  socialNetworkSettings?: InputMaybe<SettingsSocialNetworkSettingsFilter>;
  trackingSettings?: InputMaybe<SettingsTrackingSettingsFilter>;
  contactSettings?: InputMaybe<SettingsContactSettingsFilter>;
};

export type SettingsConnectionEdges = {
  __typename?: 'SettingsConnectionEdges';
  cursor: Scalars['String'];
  node?: Maybe<Settings>;
};

export type SettingsConnection = Connection & {
  __typename?: 'SettingsConnection';
  pageInfo: PageInfo;
  totalCount: Scalars['Float'];
  edges?: Maybe<Array<Maybe<SettingsConnectionEdges>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPendingDocument: DocumentNode;
  updateDocument: DocumentNode;
  deleteDocument: DocumentNode;
  createDocument: DocumentNode;
  updatePage: Page;
  createPage: Page;
  updateDances: Dances;
  createDances: Dances;
  updateCourses: Courses;
  createCourses: Courses;
  updateMenu: Menu;
  createMenu: Menu;
  updateSettings: Settings;
  createSettings: Settings;
};


export type MutationAddPendingDocumentArgs = {
  collection: Scalars['String'];
  relativePath: Scalars['String'];
  template?: InputMaybe<Scalars['String']>;
};


export type MutationUpdateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']>;
  relativePath: Scalars['String'];
  params: DocumentUpdateMutation;
};


export type MutationDeleteDocumentArgs = {
  collection?: InputMaybe<Scalars['String']>;
  relativePath: Scalars['String'];
};


export type MutationCreateDocumentArgs = {
  collection?: InputMaybe<Scalars['String']>;
  relativePath: Scalars['String'];
  params: DocumentMutation;
};


export type MutationUpdatePageArgs = {
  relativePath: Scalars['String'];
  params: PageMutation;
};


export type MutationCreatePageArgs = {
  relativePath: Scalars['String'];
  params: PageMutation;
};


export type MutationUpdateDancesArgs = {
  relativePath: Scalars['String'];
  params: DancesMutation;
};


export type MutationCreateDancesArgs = {
  relativePath: Scalars['String'];
  params: DancesMutation;
};


export type MutationUpdateCoursesArgs = {
  relativePath: Scalars['String'];
  params: CoursesMutation;
};


export type MutationCreateCoursesArgs = {
  relativePath: Scalars['String'];
  params: CoursesMutation;
};


export type MutationUpdateMenuArgs = {
  relativePath: Scalars['String'];
  params: MenuMutation;
};


export type MutationCreateMenuArgs = {
  relativePath: Scalars['String'];
  params: MenuMutation;
};


export type MutationUpdateSettingsArgs = {
  relativePath: Scalars['String'];
  params: SettingsMutation;
};


export type MutationCreateSettingsArgs = {
  relativePath: Scalars['String'];
  params: SettingsMutation;
};

export type DocumentUpdateMutation = {
  page?: InputMaybe<PageMutation>;
  dances?: InputMaybe<DancesMutation>;
  courses?: InputMaybe<CoursesMutation>;
  menu?: InputMaybe<MenuMutation>;
  settings?: InputMaybe<SettingsMutation>;
  relativePath?: InputMaybe<Scalars['String']>;
};

export type DocumentMutation = {
  page?: InputMaybe<PageMutation>;
  dances?: InputMaybe<DancesMutation>;
  courses?: InputMaybe<CoursesMutation>;
  menu?: InputMaybe<MenuMutation>;
  settings?: InputMaybe<SettingsMutation>;
};

export type PageContentWidgetCustomContentLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  internalLink?: InputMaybe<Scalars['String']>;
  anchor?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetCustomContentLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetCustomContentLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  fileLink?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetCustomContentLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetCustomContentLinkNodesFileLinkMutation>;
};

export type PageContentWidgetCustomContentImageNodeMutation = {
  image?: InputMaybe<Scalars['String']>;
  alt?: InputMaybe<Scalars['String']>;
  credits?: InputMaybe<Scalars['String']>;
  aspectRatio?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetCustomContentMutation = {
  title?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetCustomContentLinkNodesMutation>>>;
  imageNode?: InputMaybe<PageContentWidgetCustomContentImageNodeMutation>;
};

export type PageContentWidgetBannerImageMutation = {
  image?: InputMaybe<Scalars['String']>;
  alt?: InputMaybe<Scalars['String']>;
  credits?: InputMaybe<Scalars['String']>;
  aspectRatio?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  internalLink?: InputMaybe<Scalars['String']>;
  anchor?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  fileLink?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetBannerTextLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetBannerTextLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetBannerTextLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetBannerTextLinkNodesFileLinkMutation>;
};

export type PageContentWidgetBannerTextMutation = {
  title?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetBannerTextLinkNodesMutation>>>;
};

export type PageContentWidgetImageGridGridImageNodesMutation = {
  image?: InputMaybe<Scalars['String']>;
  alt?: InputMaybe<Scalars['String']>;
  credits?: InputMaybe<Scalars['String']>;
  aspectRatio?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetImageGridGridMutation = {
  imageNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetImageGridGridImageNodesMutation>>>;
};

export type PageContentWidgetImageGridMutation = {
  grid?: InputMaybe<Array<InputMaybe<PageContentWidgetImageGridGridMutation>>>;
};

export type PageContentWidgetHeroUnitLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  internalLink?: InputMaybe<Scalars['String']>;
  anchor?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnitLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnitLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  fileLink?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnitLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetHeroUnitLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetHeroUnitLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetHeroUnitLinkNodesFileLinkMutation>;
};

export type PageContentWidgetHeroUnitImageNodeMutation = {
  image?: InputMaybe<Scalars['String']>;
  alt?: InputMaybe<Scalars['String']>;
  credits?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetHeroUnitMutation = {
  title?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetHeroUnitLinkNodesMutation>>>;
  imageNode?: InputMaybe<PageContentWidgetHeroUnitImageNodeMutation>;
};

export type PageContentWidgetListingListingMutation = {
  title?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
};

export type PageContentWidgetListingLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  internalLink?: InputMaybe<Scalars['String']>;
  anchor?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetListingLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetListingLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  fileLink?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetListingLinkNodesMutation = {
  internalLink?: InputMaybe<PageContentWidgetListingLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<PageContentWidgetListingLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<PageContentWidgetListingLinkNodesFileLinkMutation>;
};

export type PageContentWidgetListingMutation = {
  title?: InputMaybe<Scalars['String']>;
  introduction?: InputMaybe<Scalars['JSON']>;
  listing?: InputMaybe<Array<InputMaybe<PageContentWidgetListingListingMutation>>>;
  linkNodes?: InputMaybe<Array<InputMaybe<PageContentWidgetListingLinkNodesMutation>>>;
};

export type PageContentWidgetContactFormMutation = {
  title?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
  sendButton?: InputMaybe<Scalars['String']>;
  resendButton?: InputMaybe<Scalars['String']>;
  successMessage?: InputMaybe<Scalars['JSON']>;
  errorMessage?: InputMaybe<Scalars['JSON']>;
};

export type PageContentWidgetAnchorMutation = {
  name?: InputMaybe<Scalars['String']>;
};

export type PageContentWidgetAgendaMutation = {
  title?: InputMaybe<Scalars['String']>;
};

export type PageContentMutation = {
  WidgetCustomContent?: InputMaybe<PageContentWidgetCustomContentMutation>;
  WidgetBannerImage?: InputMaybe<PageContentWidgetBannerImageMutation>;
  WidgetBannerText?: InputMaybe<PageContentWidgetBannerTextMutation>;
  WidgetImageGrid?: InputMaybe<PageContentWidgetImageGridMutation>;
  WidgetHeroUnit?: InputMaybe<PageContentWidgetHeroUnitMutation>;
  WidgetListing?: InputMaybe<PageContentWidgetListingMutation>;
  WidgetContactForm?: InputMaybe<PageContentWidgetContactFormMutation>;
  WidgetAnchor?: InputMaybe<PageContentWidgetAnchorMutation>;
  WidgetAgenda?: InputMaybe<PageContentWidgetAgendaMutation>;
};

export type PageSeoMutation = {
  title?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  keywords?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
};

export type PageMutation = {
  title?: InputMaybe<Scalars['String']>;
  path?: InputMaybe<Scalars['String']>;
  parentPage?: InputMaybe<Scalars['String']>;
  draft?: InputMaybe<Scalars['Boolean']>;
  content?: InputMaybe<Array<InputMaybe<PageContentMutation>>>;
  seo?: InputMaybe<PageSeoMutation>;
};

export type DancesMutation = {
  title?: InputMaybe<Scalars['String']>;
  choreographer?: InputMaybe<Scalars['String']>;
  video_teacher?: InputMaybe<Scalars['String']>;
  video?: InputMaybe<Scalars['String']>;
  file?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['JSON']>;
};

export type CoursesDancesMutation = {
  dance?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
};

export type CoursesMutation = {
  title?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['String']>;
  season?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  dances?: InputMaybe<Array<InputMaybe<CoursesDancesMutation>>>;
};

export type MenuLinkNodesInternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  internalLink?: InputMaybe<Scalars['String']>;
  anchor?: InputMaybe<Scalars['String']>;
};

export type MenuLinkNodesExternalLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MenuLinkNodesFileLinkMutation = {
  label?: InputMaybe<Scalars['String']>;
  fileLink?: InputMaybe<Scalars['String']>;
};

export type MenuLinkNodesMutation = {
  internalLink?: InputMaybe<MenuLinkNodesInternalLinkMutation>;
  externalLink?: InputMaybe<MenuLinkNodesExternalLinkMutation>;
  fileLink?: InputMaybe<MenuLinkNodesFileLinkMutation>;
};

export type MenuMutation = {
  name?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['String']>;
  linkNodes?: InputMaybe<Array<InputMaybe<MenuLinkNodesMutation>>>;
};

export type SettingsGeneralSettingsMutation = {
  title?: InputMaybe<Scalars['String']>;
  websiteName?: InputMaybe<Scalars['String']>;
  websiteDescription?: InputMaybe<Scalars['String']>;
  websiteKeywords?: InputMaybe<Scalars['String']>;
  websiteLogo?: InputMaybe<Scalars['String']>;
  websiteIcon?: InputMaybe<Scalars['String']>;
};

export type SettingsSocialNetworkSettingsPlatformsMutation = {
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type SettingsSocialNetworkSettingsMutation = {
  title?: InputMaybe<Scalars['String']>;
  websiteShareImage?: InputMaybe<Scalars['String']>;
  platforms?: InputMaybe<Array<InputMaybe<SettingsSocialNetworkSettingsPlatformsMutation>>>;
};

export type SettingsTrackingSettingsMutation = {
  title?: InputMaybe<Scalars['String']>;
  googleAnalyticsId?: InputMaybe<Scalars['String']>;
};

export type SettingsContactSettingsMutation = {
  title?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyDescription?: InputMaybe<Scalars['String']>;
  companyLogo?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
};

export type SettingsMutation = {
  generalSettings?: InputMaybe<SettingsGeneralSettingsMutation>;
  socialNetworkSettings?: InputMaybe<SettingsSocialNetworkSettingsMutation>;
  trackingSettings?: InputMaybe<SettingsTrackingSettingsMutation>;
  contactSettings?: InputMaybe<SettingsContactSettingsMutation>;
};

export type PagePartsFragment = { __typename?: 'Page', title: string, path: string, draft?: boolean | null, parentPage?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null };

export type DancesPartsFragment = { __typename?: 'Dances', title: string, choreographer?: string | null, video_teacher?: string | null, video?: string | null, file?: string | null, notes?: any | null };

export type CoursesPartsFragment = { __typename?: 'Courses', title: string, date?: string | null, season?: string | null, description?: any | null, dances?: Array<{ __typename: 'CoursesDances', notes?: string | null, dance?: { __typename?: 'Dances', title: string, choreographer?: string | null, video_teacher?: string | null, video?: string | null, file?: string | null, notes?: any | null, id: string } | null } | null> | null };

export type MenuPartsFragment = { __typename?: 'Menu', name: string, position?: string | null, linkNodes?: Array<{ __typename: 'MenuLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'MenuLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'MenuLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null };

type SettingsParts_SettingsGeneralSettings_Fragment = { __typename?: 'SettingsGeneralSettings', title: string, websiteName: string, websiteDescription?: string | null, websiteKeywords?: string | null, websiteLogo?: string | null, websiteIcon?: string | null };

type SettingsParts_SettingsSocialNetworkSettings_Fragment = { __typename?: 'SettingsSocialNetworkSettings', title: string, websiteShareImage?: string | null, platforms?: Array<{ __typename: 'SettingsSocialNetworkSettingsPlatforms', name: string, url: string } | null> | null };

type SettingsParts_SettingsTrackingSettings_Fragment = { __typename?: 'SettingsTrackingSettings', title: string, googleAnalyticsId?: string | null };

type SettingsParts_SettingsContactSettings_Fragment = { __typename?: 'SettingsContactSettings', title: string, companyName?: string | null, companyDescription?: string | null, companyLogo?: string | null, email?: string | null, phone?: string | null, address?: string | null };

export type SettingsPartsFragment = SettingsParts_SettingsGeneralSettings_Fragment | SettingsParts_SettingsSocialNetworkSettings_Fragment | SettingsParts_SettingsTrackingSettings_Fragment | SettingsParts_SettingsContactSettings_Fragment;

export type PageQueryVariables = Exact<{
  relativePath: Scalars['String'];
}>;


export type PageQuery = { __typename?: 'Query', page: { __typename?: 'Page', id: string, title: string, path: string, draft?: boolean | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, parentPage?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } };

export type PageConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<PageFilter>;
}>;


export type PageConnectionQuery = { __typename?: 'Query', pageConnection: { __typename?: 'PageConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'PageConnectionEdges', cursor: string, node?: { __typename?: 'Page', id: string, title: string, path: string, draft?: boolean | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, parentPage?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | null> | null } };

export type DancesQueryVariables = Exact<{
  relativePath: Scalars['String'];
}>;


export type DancesQuery = { __typename?: 'Query', dances: { __typename?: 'Dances', id: string, title: string, choreographer?: string | null, video_teacher?: string | null, video?: string | null, file?: string | null, notes?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type DancesConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<DancesFilter>;
}>;


export type DancesConnectionQuery = { __typename?: 'Query', dancesConnection: { __typename?: 'DancesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'DancesConnectionEdges', cursor: string, node?: { __typename?: 'Dances', id: string, title: string, choreographer?: string | null, video_teacher?: string | null, video?: string | null, file?: string | null, notes?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export type CoursesQueryVariables = Exact<{
  relativePath: Scalars['String'];
}>;


export type CoursesQuery = { __typename?: 'Query', courses: { __typename?: 'Courses', id: string, title: string, date?: string | null, season?: string | null, description?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, dances?: Array<{ __typename: 'CoursesDances', notes?: string | null, dance?: { __typename?: 'Dances', title: string, choreographer?: string | null, video_teacher?: string | null, video?: string | null, file?: string | null, notes?: any | null, id: string } | null } | null> | null } };

export type CoursesConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<CoursesFilter>;
}>;


export type CoursesConnectionQuery = { __typename?: 'Query', coursesConnection: { __typename?: 'CoursesConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'CoursesConnectionEdges', cursor: string, node?: { __typename?: 'Courses', id: string, title: string, date?: string | null, season?: string | null, description?: any | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, dances?: Array<{ __typename: 'CoursesDances', notes?: string | null, dance?: { __typename?: 'Dances', title: string, choreographer?: string | null, video_teacher?: string | null, video?: string | null, file?: string | null, notes?: any | null, id: string } | null } | null> | null } | null } | null> | null } };

export type MenuQueryVariables = Exact<{
  relativePath: Scalars['String'];
}>;


export type MenuQuery = { __typename?: 'Query', menu: { __typename?: 'Menu', id: string, name: string, position?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, linkNodes?: Array<{ __typename: 'MenuLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'MenuLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'MenuLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } };

export type MenuConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<MenuFilter>;
}>;


export type MenuConnectionQuery = { __typename?: 'Query', menuConnection: { __typename?: 'MenuConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'MenuConnectionEdges', cursor: string, node?: { __typename?: 'Menu', id: string, name: string, position?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, linkNodes?: Array<{ __typename: 'MenuLinkNodesInternalLink', label?: string | null, anchor?: string | null, internalLink?: { __typename?: 'Page', title: string, path: string, draft?: boolean | null, id: string, content?: Array<{ __typename: 'PageContentWidgetCustomContent', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetCustomContentLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetCustomContentLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetCustomContentImageNode', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null, position?: string | null } | null } | { __typename: 'PageContentWidgetBannerImage', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | { __typename: 'PageContentWidgetBannerText', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetBannerTextLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetBannerTextLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetImageGrid', grid?: Array<{ __typename: 'PageContentWidgetImageGridGrid', imageNodes?: Array<{ __typename: 'PageContentWidgetImageGridGridImageNodes', image?: string | null, alt?: string | null, credits?: string | null, aspectRatio?: string | null } | null> | null } | null> | null } | { __typename: 'PageContentWidgetHeroUnit', title?: string | null, content?: any | null, linkNodes?: Array<{ __typename: 'PageContentWidgetHeroUnitLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetHeroUnitLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null, imageNode?: { __typename: 'PageContentWidgetHeroUnitImageNode', image?: string | null, alt?: string | null, credits?: string | null } | null } | { __typename: 'PageContentWidgetListing', title?: string | null, introduction?: any | null, listing?: Array<{ __typename: 'PageContentWidgetListingListing', title: string, content?: any | null } | null> | null, linkNodes?: Array<{ __typename: 'PageContentWidgetListingLinkNodesInternalLink', label?: string | null, anchor?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'PageContentWidgetListingLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | { __typename: 'PageContentWidgetContactForm', title?: string | null, content?: any | null, name?: string | null, sendButton?: string | null, resendButton?: string | null, successMessage?: any | null, errorMessage?: any | null } | { __typename: 'PageContentWidgetAnchor', name?: string | null } | { __typename: 'PageContentWidgetAgenda', title?: string | null } | null> | null, seo?: { __typename: 'PageSeo', title?: string | null, description?: string | null, keywords?: string | null, image?: string | null } | null } | null } | { __typename: 'MenuLinkNodesExternalLink', label?: string | null, url?: string | null } | { __typename: 'MenuLinkNodesFileLink', label?: string | null, fileLink?: string | null } | null> | null } | null } | null> | null } };

export type SettingsQueryVariables = Exact<{
  relativePath: Scalars['String'];
}>;


export type SettingsQuery = { __typename?: 'Query', settings: { __typename?: 'SettingsGeneralSettings', id: string, title: string, websiteName: string, websiteDescription?: string | null, websiteKeywords?: string | null, websiteLogo?: string | null, websiteIcon?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename?: 'SettingsSocialNetworkSettings', id: string, title: string, websiteShareImage?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, platforms?: Array<{ __typename: 'SettingsSocialNetworkSettingsPlatforms', name: string, url: string } | null> | null } | { __typename?: 'SettingsTrackingSettings', id: string, title: string, googleAnalyticsId?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename?: 'SettingsContactSettings', id: string, title: string, companyName?: string | null, companyDescription?: string | null, companyLogo?: string | null, email?: string | null, phone?: string | null, address?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } };

export type SettingsConnectionQueryVariables = Exact<{
  before?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  last?: InputMaybe<Scalars['Float']>;
  sort?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<SettingsFilter>;
}>;


export type SettingsConnectionQuery = { __typename?: 'Query', settingsConnection: { __typename?: 'SettingsConnection', totalCount: number, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, hasNextPage: boolean, startCursor: string, endCursor: string }, edges?: Array<{ __typename?: 'SettingsConnectionEdges', cursor: string, node?: { __typename?: 'SettingsGeneralSettings', id: string, title: string, websiteName: string, websiteDescription?: string | null, websiteKeywords?: string | null, websiteLogo?: string | null, websiteIcon?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename?: 'SettingsSocialNetworkSettings', id: string, title: string, websiteShareImage?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string }, platforms?: Array<{ __typename: 'SettingsSocialNetworkSettingsPlatforms', name: string, url: string } | null> | null } | { __typename?: 'SettingsTrackingSettings', id: string, title: string, googleAnalyticsId?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | { __typename?: 'SettingsContactSettings', id: string, title: string, companyName?: string | null, companyDescription?: string | null, companyLogo?: string | null, email?: string | null, phone?: string | null, address?: string | null, _sys: { __typename?: 'SystemInfo', filename: string, basename: string, breadcrumbs: Array<string>, path: string, relativePath: string, extension: string } } | null } | null> | null } };

export const PagePartsFragmentDoc = gql`
    fragment PageParts on Page {
  title
  path
  parentPage {
    ... on Page {
      title
      path
      draft
      content {
        __typename
        ... on PageContentWidgetCustomContent {
          title
          content
          linkNodes {
            __typename
            ... on PageContentWidgetCustomContentLinkNodesInternalLink {
              label
              anchor
            }
            ... on PageContentWidgetCustomContentLinkNodesExternalLink {
              label
              url
            }
            ... on PageContentWidgetCustomContentLinkNodesFileLink {
              label
              fileLink
            }
          }
          imageNode {
            __typename
            image
            alt
            credits
            aspectRatio
            position
          }
        }
        ... on PageContentWidgetBannerImage {
          image
          alt
          credits
          aspectRatio
        }
        ... on PageContentWidgetBannerText {
          title
          content
          linkNodes {
            __typename
            ... on PageContentWidgetBannerTextLinkNodesInternalLink {
              label
              anchor
            }
            ... on PageContentWidgetBannerTextLinkNodesExternalLink {
              label
              url
            }
            ... on PageContentWidgetBannerTextLinkNodesFileLink {
              label
              fileLink
            }
          }
        }
        ... on PageContentWidgetImageGrid {
          grid {
            __typename
            imageNodes {
              __typename
              image
              alt
              credits
              aspectRatio
            }
          }
        }
        ... on PageContentWidgetHeroUnit {
          title
          content
          linkNodes {
            __typename
            ... on PageContentWidgetHeroUnitLinkNodesInternalLink {
              label
              anchor
            }
            ... on PageContentWidgetHeroUnitLinkNodesExternalLink {
              label
              url
            }
            ... on PageContentWidgetHeroUnitLinkNodesFileLink {
              label
              fileLink
            }
          }
          imageNode {
            __typename
            image
            alt
            credits
          }
        }
        ... on PageContentWidgetListing {
          title
          introduction
          listing {
            __typename
            title
            content
          }
          linkNodes {
            __typename
            ... on PageContentWidgetListingLinkNodesInternalLink {
              label
              anchor
            }
            ... on PageContentWidgetListingLinkNodesExternalLink {
              label
              url
            }
            ... on PageContentWidgetListingLinkNodesFileLink {
              label
              fileLink
            }
          }
        }
        ... on PageContentWidgetContactForm {
          title
          content
          name
          sendButton
          resendButton
          successMessage
          errorMessage
        }
        ... on PageContentWidgetAnchor {
          name
        }
        ... on PageContentWidgetAgenda {
          title
        }
      }
      seo {
        __typename
        title
        description
        keywords
        image
      }
    }
    ... on Document {
      id
    }
  }
  draft
  content {
    __typename
    ... on PageContentWidgetCustomContent {
      title
      content
      linkNodes {
        __typename
        ... on PageContentWidgetCustomContentLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              title
              path
              draft
              content {
                __typename
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                    position
                  }
                }
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetBannerText {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBannerTextLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetBannerTextLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetBannerTextLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                }
                ... on PageContentWidgetHeroUnit {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeroUnitLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                }
                ... on PageContentWidgetListing {
                  title
                  introduction
                  listing {
                    __typename
                    title
                    content
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetListingLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetListingLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetListingLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
                ... on PageContentWidgetAgenda {
                  title
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              id
            }
          }
          anchor
        }
        ... on PageContentWidgetCustomContentLinkNodesExternalLink {
          label
          url
        }
        ... on PageContentWidgetCustomContentLinkNodesFileLink {
          label
          fileLink
        }
      }
      imageNode {
        __typename
        image
        alt
        credits
        aspectRatio
        position
      }
    }
    ... on PageContentWidgetBannerImage {
      image
      alt
      credits
      aspectRatio
    }
    ... on PageContentWidgetBannerText {
      title
      content
      linkNodes {
        __typename
        ... on PageContentWidgetBannerTextLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              title
              path
              draft
              content {
                __typename
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                    position
                  }
                }
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetBannerText {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBannerTextLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetBannerTextLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetBannerTextLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                }
                ... on PageContentWidgetHeroUnit {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeroUnitLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                }
                ... on PageContentWidgetListing {
                  title
                  introduction
                  listing {
                    __typename
                    title
                    content
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetListingLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetListingLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetListingLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
                ... on PageContentWidgetAgenda {
                  title
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              id
            }
          }
          anchor
        }
        ... on PageContentWidgetBannerTextLinkNodesExternalLink {
          label
          url
        }
        ... on PageContentWidgetBannerTextLinkNodesFileLink {
          label
          fileLink
        }
      }
    }
    ... on PageContentWidgetImageGrid {
      grid {
        __typename
        imageNodes {
          __typename
          image
          alt
          credits
          aspectRatio
        }
      }
    }
    ... on PageContentWidgetHeroUnit {
      title
      content
      linkNodes {
        __typename
        ... on PageContentWidgetHeroUnitLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              title
              path
              draft
              content {
                __typename
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                    position
                  }
                }
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetBannerText {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBannerTextLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetBannerTextLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetBannerTextLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                }
                ... on PageContentWidgetHeroUnit {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeroUnitLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                }
                ... on PageContentWidgetListing {
                  title
                  introduction
                  listing {
                    __typename
                    title
                    content
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetListingLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetListingLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetListingLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
                ... on PageContentWidgetAgenda {
                  title
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              id
            }
          }
          anchor
        }
        ... on PageContentWidgetHeroUnitLinkNodesExternalLink {
          label
          url
        }
        ... on PageContentWidgetHeroUnitLinkNodesFileLink {
          label
          fileLink
        }
      }
      imageNode {
        __typename
        image
        alt
        credits
      }
    }
    ... on PageContentWidgetListing {
      title
      introduction
      listing {
        __typename
        title
        content
      }
      linkNodes {
        __typename
        ... on PageContentWidgetListingLinkNodesInternalLink {
          label
          internalLink {
            ... on Page {
              title
              path
              draft
              content {
                __typename
                ... on PageContentWidgetCustomContent {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetCustomContentLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                    aspectRatio
                    position
                  }
                }
                ... on PageContentWidgetBannerImage {
                  image
                  alt
                  credits
                  aspectRatio
                }
                ... on PageContentWidgetBannerText {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetBannerTextLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetBannerTextLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetBannerTextLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetImageGrid {
                  grid {
                    __typename
                    imageNodes {
                      __typename
                      image
                      alt
                      credits
                      aspectRatio
                    }
                  }
                }
                ... on PageContentWidgetHeroUnit {
                  title
                  content
                  linkNodes {
                    __typename
                    ... on PageContentWidgetHeroUnitLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetHeroUnitLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                  imageNode {
                    __typename
                    image
                    alt
                    credits
                  }
                }
                ... on PageContentWidgetListing {
                  title
                  introduction
                  listing {
                    __typename
                    title
                    content
                  }
                  linkNodes {
                    __typename
                    ... on PageContentWidgetListingLinkNodesInternalLink {
                      label
                      anchor
                    }
                    ... on PageContentWidgetListingLinkNodesExternalLink {
                      label
                      url
                    }
                    ... on PageContentWidgetListingLinkNodesFileLink {
                      label
                      fileLink
                    }
                  }
                }
                ... on PageContentWidgetContactForm {
                  title
                  content
                  name
                  sendButton
                  resendButton
                  successMessage
                  errorMessage
                }
                ... on PageContentWidgetAnchor {
                  name
                }
                ... on PageContentWidgetAgenda {
                  title
                }
              }
              seo {
                __typename
                title
                description
                keywords
                image
              }
            }
            ... on Document {
              id
            }
          }
          anchor
        }
        ... on PageContentWidgetListingLinkNodesExternalLink {
          label
          url
        }
        ... on PageContentWidgetListingLinkNodesFileLink {
          label
          fileLink
        }
      }
    }
    ... on PageContentWidgetContactForm {
      title
      content
      name
      sendButton
      resendButton
      successMessage
      errorMessage
    }
    ... on PageContentWidgetAnchor {
      name
    }
    ... on PageContentWidgetAgenda {
      title
    }
  }
  seo {
    __typename
    title
    description
    keywords
    image
  }
}
    `;
export const DancesPartsFragmentDoc = gql`
    fragment DancesParts on Dances {
  title
  choreographer
  video_teacher
  video
  file
  notes
}
    `;
export const CoursesPartsFragmentDoc = gql`
    fragment CoursesParts on Courses {
  title
  date
  season
  description
  dances {
    __typename
    dance {
      ... on Dances {
        title
        choreographer
        video_teacher
        video
        file
        notes
      }
      ... on Document {
        id
      }
    }
    notes
  }
}
    `;
export const MenuPartsFragmentDoc = gql`
    fragment MenuParts on Menu {
  name
  position
  linkNodes {
    __typename
    ... on MenuLinkNodesInternalLink {
      label
      internalLink {
        ... on Page {
          title
          path
          draft
          content {
            __typename
            ... on PageContentWidgetCustomContent {
              title
              content
              linkNodes {
                __typename
                ... on PageContentWidgetCustomContentLinkNodesInternalLink {
                  label
                  anchor
                }
                ... on PageContentWidgetCustomContentLinkNodesExternalLink {
                  label
                  url
                }
                ... on PageContentWidgetCustomContentLinkNodesFileLink {
                  label
                  fileLink
                }
              }
              imageNode {
                __typename
                image
                alt
                credits
                aspectRatio
                position
              }
            }
            ... on PageContentWidgetBannerImage {
              image
              alt
              credits
              aspectRatio
            }
            ... on PageContentWidgetBannerText {
              title
              content
              linkNodes {
                __typename
                ... on PageContentWidgetBannerTextLinkNodesInternalLink {
                  label
                  anchor
                }
                ... on PageContentWidgetBannerTextLinkNodesExternalLink {
                  label
                  url
                }
                ... on PageContentWidgetBannerTextLinkNodesFileLink {
                  label
                  fileLink
                }
              }
            }
            ... on PageContentWidgetImageGrid {
              grid {
                __typename
                imageNodes {
                  __typename
                  image
                  alt
                  credits
                  aspectRatio
                }
              }
            }
            ... on PageContentWidgetHeroUnit {
              title
              content
              linkNodes {
                __typename
                ... on PageContentWidgetHeroUnitLinkNodesInternalLink {
                  label
                  anchor
                }
                ... on PageContentWidgetHeroUnitLinkNodesExternalLink {
                  label
                  url
                }
                ... on PageContentWidgetHeroUnitLinkNodesFileLink {
                  label
                  fileLink
                }
              }
              imageNode {
                __typename
                image
                alt
                credits
              }
            }
            ... on PageContentWidgetListing {
              title
              introduction
              listing {
                __typename
                title
                content
              }
              linkNodes {
                __typename
                ... on PageContentWidgetListingLinkNodesInternalLink {
                  label
                  anchor
                }
                ... on PageContentWidgetListingLinkNodesExternalLink {
                  label
                  url
                }
                ... on PageContentWidgetListingLinkNodesFileLink {
                  label
                  fileLink
                }
              }
            }
            ... on PageContentWidgetContactForm {
              title
              content
              name
              sendButton
              resendButton
              successMessage
              errorMessage
            }
            ... on PageContentWidgetAnchor {
              name
            }
            ... on PageContentWidgetAgenda {
              title
            }
          }
          seo {
            __typename
            title
            description
            keywords
            image
          }
        }
        ... on Document {
          id
        }
      }
      anchor
    }
    ... on MenuLinkNodesExternalLink {
      label
      url
    }
    ... on MenuLinkNodesFileLink {
      label
      fileLink
    }
  }
}
    `;
export const SettingsPartsFragmentDoc = gql`
    fragment SettingsParts on Settings {
  ... on SettingsGeneralSettings {
    title
    websiteName
    websiteDescription
    websiteKeywords
    websiteLogo
    websiteIcon
  }
  ... on SettingsSocialNetworkSettings {
    title
    websiteShareImage
    platforms {
      __typename
      name
      url
    }
  }
  ... on SettingsTrackingSettings {
    title
    googleAnalyticsId
  }
  ... on SettingsContactSettings {
    title
    companyName
    companyDescription
    companyLogo
    email
    phone
    address
  }
}
    `;
export const PageDocument = gql`
    query page($relativePath: String!) {
  page(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PageParts
  }
}
    ${PagePartsFragmentDoc}`;
export const PageConnectionDocument = gql`
    query pageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PageFilter) {
  pageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PageParts
      }
    }
  }
}
    ${PagePartsFragmentDoc}`;
export const DancesDocument = gql`
    query dances($relativePath: String!) {
  dances(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...DancesParts
  }
}
    ${DancesPartsFragmentDoc}`;
export const DancesConnectionDocument = gql`
    query dancesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: DancesFilter) {
  dancesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...DancesParts
      }
    }
  }
}
    ${DancesPartsFragmentDoc}`;
export const CoursesDocument = gql`
    query courses($relativePath: String!) {
  courses(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CoursesParts
  }
}
    ${CoursesPartsFragmentDoc}`;
export const CoursesConnectionDocument = gql`
    query coursesConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CoursesFilter) {
  coursesConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CoursesParts
      }
    }
  }
}
    ${CoursesPartsFragmentDoc}`;
export const MenuDocument = gql`
    query menu($relativePath: String!) {
  menu(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...MenuParts
  }
}
    ${MenuPartsFragmentDoc}`;
export const MenuConnectionDocument = gql`
    query menuConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: MenuFilter) {
  menuConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...MenuParts
      }
    }
  }
}
    ${MenuPartsFragmentDoc}`;
export const SettingsDocument = gql`
    query settings($relativePath: String!) {
  settings(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...SettingsParts
  }
}
    ${SettingsPartsFragmentDoc}`;
export const SettingsConnectionDocument = gql`
    query settingsConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: SettingsFilter) {
  settingsConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...SettingsParts
      }
    }
  }
}
    ${SettingsPartsFragmentDoc}`;
export type Requester<C= {}> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R>
  export function getSdk<C>(requester: Requester<C>) {
    return {
      page(variables: PageQueryVariables, options?: C): Promise<{data: PageQuery, variables: PageQueryVariables, query: string}> {
        return requester<{data: PageQuery, variables: PageQueryVariables, query: string}, PageQueryVariables>(PageDocument, variables, options);
      },
    pageConnection(variables?: PageConnectionQueryVariables, options?: C): Promise<{data: PageConnectionQuery, variables: PageConnectionQueryVariables, query: string}> {
        return requester<{data: PageConnectionQuery, variables: PageConnectionQueryVariables, query: string}, PageConnectionQueryVariables>(PageConnectionDocument, variables, options);
      },
    dances(variables: DancesQueryVariables, options?: C): Promise<{data: DancesQuery, variables: DancesQueryVariables, query: string}> {
        return requester<{data: DancesQuery, variables: DancesQueryVariables, query: string}, DancesQueryVariables>(DancesDocument, variables, options);
      },
    dancesConnection(variables?: DancesConnectionQueryVariables, options?: C): Promise<{data: DancesConnectionQuery, variables: DancesConnectionQueryVariables, query: string}> {
        return requester<{data: DancesConnectionQuery, variables: DancesConnectionQueryVariables, query: string}, DancesConnectionQueryVariables>(DancesConnectionDocument, variables, options);
      },
    courses(variables: CoursesQueryVariables, options?: C): Promise<{data: CoursesQuery, variables: CoursesQueryVariables, query: string}> {
        return requester<{data: CoursesQuery, variables: CoursesQueryVariables, query: string}, CoursesQueryVariables>(CoursesDocument, variables, options);
      },
    coursesConnection(variables?: CoursesConnectionQueryVariables, options?: C): Promise<{data: CoursesConnectionQuery, variables: CoursesConnectionQueryVariables, query: string}> {
        return requester<{data: CoursesConnectionQuery, variables: CoursesConnectionQueryVariables, query: string}, CoursesConnectionQueryVariables>(CoursesConnectionDocument, variables, options);
      },
    menu(variables: MenuQueryVariables, options?: C): Promise<{data: MenuQuery, variables: MenuQueryVariables, query: string}> {
        return requester<{data: MenuQuery, variables: MenuQueryVariables, query: string}, MenuQueryVariables>(MenuDocument, variables, options);
      },
    menuConnection(variables?: MenuConnectionQueryVariables, options?: C): Promise<{data: MenuConnectionQuery, variables: MenuConnectionQueryVariables, query: string}> {
        return requester<{data: MenuConnectionQuery, variables: MenuConnectionQueryVariables, query: string}, MenuConnectionQueryVariables>(MenuConnectionDocument, variables, options);
      },
    settings(variables: SettingsQueryVariables, options?: C): Promise<{data: SettingsQuery, variables: SettingsQueryVariables, query: string}> {
        return requester<{data: SettingsQuery, variables: SettingsQueryVariables, query: string}, SettingsQueryVariables>(SettingsDocument, variables, options);
      },
    settingsConnection(variables?: SettingsConnectionQueryVariables, options?: C): Promise<{data: SettingsConnectionQuery, variables: SettingsConnectionQueryVariables, query: string}> {
        return requester<{data: SettingsConnectionQuery, variables: SettingsConnectionQueryVariables, query: string}, SettingsConnectionQueryVariables>(SettingsConnectionDocument, variables, options);
      }
    };
  }
  export type Sdk = ReturnType<typeof getSdk>;

// TinaSDK generated code
import { createClient, TinaClient } from "tinacms/dist/client";

const generateRequester = (client: TinaClient) => {
  const requester: (
    doc: any,
    vars?: any,
    options?: any,
    client
  ) => Promise<any> = async (doc, vars, _options) => {
    const data = await client.request({
      query: doc,
      variables: vars,
    });

    return { data: data?.data, query: doc, variables: vars || {} };
  };

  return requester;
};

/**
 * @experimental this class can be used but may change in the future
 **/
export const ExperimentalGetTinaClient = () =>
  getSdk(
    generateRequester(createClient({ url: "https://content.tinajs.io/1.4/content/70b94789-1850-4a46-a93b-72d8e6fb3fda/github/main", queries }))
  );

export const queries = (client: TinaClient) => {
  const requester = generateRequester(client);
  return getSdk(requester);
};

  